import { useState, useCallback, useContext } from 'react';
import useRecipeV2Api from './useRecipeV2Api';
import { RecipeV2, RecipeV2ListResponse } from '../types';
import { UserContext } from '../../../components/shared/useUser';

const useRecipeV2List = () => {
  const { getRecipes } = useRecipeV2Api();
  const { selectedStore } = useContext(UserContext);
  const [recipes, setRecipes] = useState<RecipeV2[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadRecipes = useCallback(async (search: string, page: number, pageSize: number) => {
    setIsLoading(true);
    setError(null);
    try {
      const response: RecipeV2ListResponse = await getRecipes(search, page + 1, pageSize, selectedStore?.storeNumber);
      setRecipes(response.data);
      setTotalCount(response.totalCount);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load recipes');
      setRecipes([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  }, [getRecipes, selectedStore?.storeNumber]);

  return { recipes, totalCount, isLoading, error, loadRecipes };
};

export default useRecipeV2List;
